export const AUTH_CALLBACK_EVENTS = {
    SALESFORCE: 'salesforceOAuthCallback',
    MS_DYNAMICS: 'msDynamicsOAuthCallback',
    HUBSPOT: 'hubspotOAuthCallback',
};
